import { render, staticRenderFns } from "./PCLayout.vue?vue&type=template&id=3a33bd50&"
import script from "./PCLayout.vue?vue&type=script&lang=js&"
export * from "./PCLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports